<script>
    import { createEventDispatcher } from 'svelte';

    export let items = [];
    export let defaults = null;
    export let selectedIds = [];   // массив id уже выбранных менеджеров

    const dispatch = createEventDispatcher();

    let search = '';
    let isOpen = false;

    $: filteredItems = items.filter(item =>
        item?.name && item.name.toLowerCase().includes((search ?? '').toLowerCase())
    );

    function selectItem(item) {
        if (!item?.name) return;
        dispatch('select', item);
        // НЕ закрываем список и НЕ сбрасываем поиск —
        // чтобы можно было выбрать нескольких подряд
    }
</script>

<div class="manager-search-wrapper">
    <input
            class="form-control"
            type="text"
            placeholder="Поиск менеджера..."
            bind:value={search}
            on:focus={() => (isOpen = true)}
            on:blur={() => setTimeout(() => (isOpen = false), 200)}
    />

    {#if isOpen && filteredItems.length > 0}
        <ul class="manager-dropdown">
            {#each filteredItems as item}
                <li
                        class="manager-option"
                        class:is-selected={selectedIds.includes(item.id)}
                        on:mousedown|preventDefault={() => selectItem(item)}
                >
                    <span class="option-name">{item.name}</span>
                    {#if selectedIds.includes(item.id)}
                        <span class="option-check">✓</span>
                    {/if}
                </li>
            {/each}
        </ul>
    {/if}
</div>

<style>
    .manager-search-wrapper {
        position: relative;
        width: 100%;
    }

    .manager-dropdown {
        position: absolute;
        top: calc(100% + 4px);
        left: 0;
        right: 0;
        background: #fff;
        border: 1px solid #d4d1ca;
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
        list-style: none;
        margin: 0;
        padding: 4px 0;
        max-height: 220px;
        overflow-y: auto;
        z-index: 100;
    }

    .manager-option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 9px 14px;
        cursor: pointer;
        font-size: 14px;
        color: #28251d;
        transition: background 0.12s;
        border-radius: 4px;
        margin: 0 4px;
    }

    .manager-option:hover {
        background-color: #f3f0ec;
    }

    .manager-option.is-selected {
        background-color: #e8f4f5;
        color: #01696f;
        font-weight: 500;
    }

    .option-name {
        flex: 1;
    }

    .option-check {
        color: #01696f;
        font-weight: 700;
        font-size: 15px;
        margin-left: 8px;
        flex-shrink: 0;
    }
</style>